module.exports = __webpack_public_path__ + "static/media/bronze.0aca9bc7.svg";